import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "../../data/velvet";
import { MaskLine, FadeUp, Overline } from "./Reveal";

const STATS = [
  ["Home of", "The Velvet Testament"],
  ["Voices", "Five"],
  ["Sound", "Original Soul"],
  ["Ethos", "Independent"],
];

export const Lantern = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "12%"]);

  return (
    <section
      id="label"
      data-testid="label-section"
      ref={ref}
      className="relative overflow-hidden"
    >
      <motion.div style={{ y, scale: 1.15 }} className="absolute inset-0">
        <img
          src={IMAGES.lantern}
          alt="A vintage brass oil lantern glowing beside stacked vinyl records in darkness"
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-vt-black/80" />
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-vt-black via-transparent to-vt-black" />

      <div className="relative z-10 mx-auto max-w-[1600px] px-6 py-28 md:px-16 md:py-44 lg:px-24">
        <div className="max-w-3xl">
          <div className="mb-8 flex items-center gap-4">
            <span className="vt-flicker text-2xl text-vt-gold">✦</span>
            <Overline>The Home of The Velvet Testament</Overline>
          </div>
          <h2 className="font-serif font-light leading-[0.95] tracking-tight text-vt-cream">
            <span className="block text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
              <MaskLine>Old Lantern</MaskLine>
            </span>
            <span className="block text-5xl italic text-vt-gold sm:text-6xl md:text-7xl lg:text-8xl">
              <MaskLine delay={0.08}>Records</MaskLine>
            </span>
          </h2>

          <FadeUp delay={0.15}>
            <p className="mt-9 max-w-xl font-body text-base font-light leading-relaxed tracking-wide text-vt-ash md:text-lg">
              Old Lantern Records is the home of The Velvet Testament — an
              independent label built around original soul music, recurring
              voices and timeless storytelling. No trends, no committees; only
              voices worth remembering.
            </p>
          </FadeUp>

          <div className="mt-14 grid grid-cols-2 gap-8 border-t border-vt-gold/15 pt-10 md:grid-cols-4">
            {STATS.map(([label, value], i) => (
              <FadeUp key={label} delay={i * 0.08}>
                <div>
                  <Overline className="text-vt-muted">{label}</Overline>
                  <p className="mt-2 font-serif text-2xl tracking-tight text-vt-cream md:text-3xl">
                    {value}
                  </p>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
